/** biome-ignore-all lint/suspicious/noConsole: false positive */

import { DatadogTrack } from '@cobliteam/datadog-rum';
import { cn } from '@cobliteam/ui/utils';
import type React from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import PageBackButton from './components/PageBackButton';
import PageBody from './components/PageBody';
import PageError from './components/PageError';
import PageFavorite from './components/PageFavorite';
import PageFilters from './components/PageFilters';
import PageFooter from './components/PageFooter';
import PageHeader from './components/PageHeader';
import PageLoading from './components/PageLoading';
import PageScrollToTop from './components/PageScrollToTop';
import PageTabs from './components/PageTabs';
import PageTitle from './components/PageTitle';
import PageWarning from './components/PageWarning';

export interface PageProps {
  children: React.ReactNode;
  /**
   * Adds a container to the page
   */
  container?: boolean;
  showFooter?: boolean;
  /**
   * Shows a floating button to scroll back to the top when the user has scrolled down
   */
  showScrollToTop?: boolean;
  className?: string;
  borderTop?: boolean;
}

const Page = ({ children, className, container = true, showFooter = true, showScrollToTop = true }: PageProps) => {
  return (
    <ErrorBoundary
      fallback={<Page.Error />}
      onError={(error, errorInfo) => {
        DatadogTrack.error(error, {
          component: 'Page',
          section: 'Layout',
          errorInfo,
        });
      }}
    >
      <div className={cn('flex min-h-full flex-col', container && 'container')}>
        <main className={cn('relative flex flex-1 flex-col gap-5 p-5', { 'pb-16': showFooter }, className)}>{children}</main>
      </div>
      {showFooter && <PageFooter />}
      {showScrollToTop && <PageScrollToTop />}
    </ErrorBoundary>
  );
};

Page.BackButton = PageBackButton;
Page.ScrollToTop = PageScrollToTop;
Page.Header = PageHeader;
Page.PageTitle = PageTitle;
Page.HeaderTitle = PageHeader.Title;
Page.HeaderActions = PageHeader.Actions;
Page.Title = PageTitle;
Page.Favorite = PageFavorite;
Page.Filters = PageFilters;
Page.Tabs = PageTabs;
Page.Body = PageBody;
Page.Footer = PageFooter;
Page.Loading = PageLoading;
Page.Error = PageError;
Page.Warning = PageWarning;

export default Page;
